// PWA Registration and Update Management
export class PWARegistration {
  private updateSW: ((reloadPage?: boolean) => Promise<void>) | undefined;

  constructor() {
    // Dynamic import to handle virtual module
    // @ts-ignore - virtual:pwa-register is provided by vite-plugin-pwa
    import('virtual:pwa-register').then(({ registerSW }) => {
      this.updateSW = registerSW({
        onNeedRefresh: () => {
          // Show update notification
          console.log('New version available');
          this.showUpdateNotification();
        },
        onOfflineReady: () => {
          // App is ready for offline use
          console.log('App ready for offline use');
        },
        onRegistered: (swRegistration: ServiceWorkerRegistration) => {
          // Service worker registered
          console.log('Service worker registered', swRegistration.scope);
        },
        onRegisterError: (error: Error) => {
          // Service worker registration failed
          console.error('Service worker registration failed:', error);
        },
      });
    }).catch((error) => {
      console.error('Failed to load PWA registration:', error);
    });
  }

  // Show update notification
  private showUpdateNotification(): void {
    // You can customize this to show a toast or modal
    if (confirm('A new version is available. Would you like to update?')) {
      this.updateSW?.(true);
    }
  }

  // Manual update check
  async checkForUpdates(): Promise<void> {
    if (this.updateSW) {
      await this.updateSW();
    }
  }

  // Force update
  async forceUpdate(): Promise<void> {
    if (this.updateSW) {
      await this.updateSW(true);
    }
  }
}

// Export singleton instance
export const pwaRegistration = new PWARegistration();

// Initialize PWA features
export function initializePWA(): void {
  // Register service worker
  pwaRegistration;

  // Request notification permission
  if ('Notification' in window) {
    Notification.requestPermission();
  }

  // Register periodic background sync if supported
  if ('serviceWorker' in navigator && 'periodicSync' in navigator.serviceWorker) {
    navigator.serviceWorker.ready.then((registration) => {
      // Register periodic background sync
      (registration as any).periodicSync.register('background-sync', {
        minInterval: 24 * 60 * 60 * 1000, // 24 hours
      }).catch((error: Error) => {
        console.log('Periodic background sync not supported:', error);
      });
    });
  }

  // Handle beforeinstallprompt for PWA installation
  let deferredPrompt: any;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    
    // You can show an install button here
    console.log('PWA install prompt available', deferredPrompt);
  });

  // Handle app installed
  window.addEventListener('appinstalled', () => {
    console.log('PWA installed successfully');
    deferredPrompt = null;
  });
} 